<template>
  <a :href="url" @click.prevent="toLink()">
    <slot ></slot>
  </a>
</template>
<script>
import {list, defaultLocale} from "../../translate";
import {mapGetters} from "vuex";

export default {
  name: "vRouterLink",
  props: {
    to: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters(["getAppLanguage"]),
    url() {
      if(this.getAppLanguage == defaultLocale) {
        if(this.to == "" || this.to == "/") {
          return "/"
        }
        return this.to
      }
      return (this.getAppLanguage == defaultLocale? "" : "/" + this.getAppLanguage) + (this.to == "" || this.to == "/" ?  "" : this.to)
    }
  },
  methods: {
    toLink() {
      this.$router.push(this.url)
    }
  },
}
</script>